export default __webpack_public_path__ + "static/media/eye.c86ebde6.svg";